import React from 'react'
import { MotionCard, MotionSection } from '../components/motion/Motion'
import SEO from '../components/seo/SEO'

export default function TermsAndConditionsOfSale() {
  return (
    <>
      <SEO
        title="Terms and Conditions of Sale | Logo Branded Door Mats Zambia"
        description="Read the terms and conditions of sale for Logo Branded Door Mats Zambia. Information about quotes, orders, payment terms, delivery, returns, and warranties for custom branded door mats."
        keywords="terms and conditions, door mat terms, sale conditions, mat purchase terms, custom mat terms, branded mat conditions, mat warranty terms"
        url="https://www.logobrandeddoormats.co.zm/terms-and-conditions-of-sale"
        image="https://www.logobrandeddoormats.co.zm/images/logo/LOGO%20HEADER.png"
      />
      <MotionSection className="w-[96%] mx-auto py-12 lg:py-16">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-3xl sm:text-4xl font-bold text-pink-500">Terms and Conditions of Sale</h1>
        <p className="mt-3 text-sm sm:text-base text-gray-700 leading-relaxed">
          These Terms and Conditions of Sale apply to all orders placed with{' '}
          <span className="font-semibold text-pink-500">Logo Branded Door Mats Zambia</span> ("we", "us", "our"). By placing an order,
          you agree to these terms.
        </p>

        <div className="mt-10 space-y-8 text-gray-800">
          <MotionCard className="" delay={0.02}>
            <h2 className="text-lg font-semibold text-pink-500">1. Quotes and Orders</h2>
            <p className="mt-2 text-sm sm:text-base leading-relaxed">
              All quotes are valid for a limited time unless stated otherwise. An order is confirmed only once we receive written approval
              of the final artwork/specification and any required deposit or full payment.
            </p>
          </MotionCard>

          <MotionCard className="" delay={0.05}>
            <h2 className="text-lg font-semibold text-pink-500">2. Artwork Approval</h2>
            <p className="mt-2 text-sm sm:text-base leading-relaxed">
              You are responsible for reviewing and approving artwork proofs carefully. Once approved, changes may not be possible and may
              incur additional costs and delays.
            </p>
          </MotionCard>

          <MotionCard className="" delay={0.08}>
            <h2 className="text-lg font-semibold text-pink-500">3. Pricing</h2>
            <p className="mt-2 text-sm sm:text-base leading-relaxed">
              Prices are as quoted and may exclude delivery, installation, duties/taxes (where applicable), or special handling unless
              expressly included in writing.
            </p>
          </MotionCard>

          <MotionCard className="" delay={0.11}>
            <h2 className="text-lg font-semibold text-pink-500">4. Payment Terms</h2>
            <p className="mt-2 text-sm sm:text-base leading-relaxed">
              Payment terms will be stated on your quotation or invoice. Production may begin only after payment is received according to
              the agreed terms.
            </p>
          </MotionCard>

          <MotionCard className="" delay={0.14}>
            <h2 className="text-lg font-semibold text-pink-500">5. Production and Lead Times</h2>
            <p className="mt-2 text-sm sm:text-base leading-relaxed">
              Lead times are estimates and can vary due to material availability, production scheduling, shipping, or clearance. We will
              always aim to deliver within the timeframe communicated at order confirmation.
            </p>
          </MotionCard>

          <MotionCard className="" delay={0.17}>
            <h2 className="text-lg font-semibold text-pink-500">6. Delivery</h2>
            <p className="mt-2 text-sm sm:text-base leading-relaxed">
              Delivery dates are not guaranteed. Risk of loss passes to you upon delivery. Please inspect goods upon receipt and report
              visible damage as soon as possible.
            </p>
          </MotionCard>

          <MotionCard className="" delay={0.2}>
            <h2 className="text-lg font-semibold text-pink-500">7. Returns and Refunds</h2>
            <p className="mt-2 text-sm sm:text-base leading-relaxed">
              Custom branded mats are made to order and are generally not returnable unless defective or not produced according to the
              approved specification. If there is an issue, contact us promptly so we can assess and resolve it.
            </p>
          </MotionCard>

          <MotionCard className="" delay={0.23}>
            <h2 className="text-lg font-semibold text-pink-500">8. Warranty and Care</h2>
            <p className="mt-2 text-sm sm:text-base leading-relaxed">
              Product performance depends on correct use and maintenance. Any care instructions provided should be followed to achieve the
              best lifespan and appearance.
            </p>
          </MotionCard>

          <MotionCard className="" delay={0.26}>
            <h2 className="text-lg font-semibold text-pink-500">9. Limitation of Liability</h2>
            <p className="mt-2 text-sm sm:text-base leading-relaxed">
              To the maximum extent permitted by law, our liability is limited to the value of the goods supplied. We are not liable for
              indirect or consequential losses such as lost profits, business interruption, or reputational damage.
            </p>
          </MotionCard>

          <MotionCard className="" delay={0.29}>
            <h2 className="text-lg font-semibold text-pink-500">10. Intellectual Property</h2>
            <p className="mt-2 text-sm sm:text-base leading-relaxed">
              You confirm you have the right to use any logos, trademarks, and artwork supplied. You indemnify us against claims arising
              from unauthorized use.
            </p>
          </MotionCard>

          <MotionCard className="" delay={0.32}>
            <h2 className="text-lg font-semibold text-pink-500">11. Privacy</h2>
            <p className="mt-2 text-sm sm:text-base leading-relaxed">
              We may use your contact information to process orders and provide updates. We do not sell your personal information.
            </p>
          </MotionCard>

          <MotionCard className="" delay={0.35}>
            <h2 className="text-lg font-semibold text-pink-500">12. Contact</h2>
            <p className="mt-2 text-sm sm:text-base leading-relaxed">
              If you have questions about these terms, please contact us via the Contact page.
            </p>
          </MotionCard>

          <p className="text-xs text-gray-500">Last updated: {new Date().getFullYear()}</p>
        </div>
      </div>
    </MotionSection>
    </>
  )
}
